/**
 * Created by wjjn3481 on 2017/5/23.
 */

import { dateFormat } from 'modules/tools'

export default {
    data () {
        let that = this
        return {
            startDateOption: {
                disabledDate (date) {
                    if (that.rangeEndDate === '') {
                        return false
                    } else {
                        return that.compareDate(date, dateFormat(that.rangeEndDate))
                    }
                }
            },
            endDateOption: {
                disabledDate (date) {
                    if (that.rangeStartDate === '') {
                        return false
                    } else {
                        return !that.compareDate(date, dateFormat(that.rangeStartDate))
                    }
                }
            }
        }
    },

    computed: {
        rangeStartDate () {
            return this.ruleForm.startDate || this.ruleForm.beginTime
        },
        rangeEndDate () {
            return this.ruleForm.endDate || this.ruleForm.endTime
        }
    },

    methods: {
        startDateChange () {
            this.$refs.endDate.$forceUpdate()
        },
        endDateChange () {
            this.$refs.startDate.$forceUpdate()
        },
        resetTime (date) {
            if (typeof date === 'string') {
                date = new Date(date)
            }
            date.setHours(0)
            date.setMinutes(0)
            date.setSeconds(0)
            date.setMilliseconds(0)
            return date
        },
        compareDate (date1, date2) {
            if (date1 === '' || date2 === '') {
                return false
            }
            return (this.resetTime(date1).getTime() - this.resetTime(date2).getTime()) > 0
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/dateOptionMixin.js